//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from '@/vueI18n';

export default {
  name: 'sama-el-baraka-footer',
  data() {
    return {
      socialList: [
        {
          icon: 'fa-facebook-f',
          url: 'https://www.facebook.com/SamaElbaraka/',
        },
      ],
    };
  },
  computed: {
    language() {
      return i18n.locale;
    },
  },
};
